import React from "react";

import errorSystem_light from "../images/errorSystem_light.png";
import DocumentTitle from "react-document-title";
import { setPageTitle } from "./setPageTitle";

export const ErrorComponent = ({ errorMsg, title, goHome = false }) => {
  setPageTitle(title || errorMsg);
  return (

    <div className="bsy-error-pane" style={{}}>
      <div className="bsy-error-content">
        <img className="" src={errorSystem_light} alt=""></img>
        <div className="error-msg">{errorMsg}</div>
        {goHome && (
          <a className="go-home" href={"/"}>
            {React.language("go.dashboard")}
          </a>
        )}
      </div>
    </div>

  );
};
